import { Button, Grid, styled, useTheme } from "@mui/material";
import { useEffect, useState } from "react";

import ActivityBox from "./Components/ActivityBox";
import FullWidthModal from "components/FullWidthModal";
import { GetLatestLoginActivity } from "store/api/activities";
import http from "config/http";
import { useNavigate } from "react-router-dom";
import useNotify from "hooks/useNotify";
import { actionButtonBg } from "utils/helpers/actionButtonBg";

function Activities({ open, onClose }) {
  const notify = useNotify();
  const theme = useTheme();

  const navigate = useNavigate();

  const [latestActivities, setLatestActivities] = useState();

  const getLatestLoginActivity = async () => {
    try {
      const { data } = await http.get(GetLatestLoginActivity);
      setLatestActivities(data?.data);
    } catch (e) {
      notify(e?.response?.data?.message, "error");
    }
  };

  useEffect(() => {
    getLatestLoginActivity();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <FullWidthModal
      dir="rtl"
      title="لیست فعالیت‌های اخیر"
      open={open}
      onClose={onClose}
    >
      <Grid container spacing={1}>
        {latestActivities?.map((activity) => (
          <Grid item xs={12}>
            <ActivityBox activity={activity} />
          </Grid>
        ))}

        <Grid item xs={12} mt={2}>
          <ButtonStyle
            onClick={() => {
              navigate("/activities");
              onClose();
            }}
            color={actionButtonBg(theme)}
            fullWidth
          >
            مشاهده تمامی فعالیت‌ها
          </ButtonStyle>
        </Grid>
      </Grid>
    </FullWidthModal>
  );
}

const ButtonStyle = styled(Button)(() => ({
  position: "sticky",
  bottom: "0",
}));

export default Activities;
